'use client';

import { useEffect } from 'react';
import useDriftClient from 'src/hooks/useDriftClient';
import useDriftClientIsReady from 'src/hooks/useDriftClientIsReady';
import {
	getDriftVaultProgram,
	VaultClient,
} from '@velocity-exchange/vaults-sdk';
import useDriftStore from '../DriftStore/useDriftStore';
import { createPlaceholderIWallet } from '@velocity-exchange/common';
import { useVaultsStore } from './useVaultsStore';

export const useSyncVaultClient = () => {
	const driftClient = useDriftClient();
	const driftClientIsReady = useDriftClientIsReady();
	const connection = useDriftStore((s) => s.connection.current);
	const setVaultsStore = useVaultsStore((s) => s.set);

	useEffect(() => {
		if (driftClientIsReady && driftClient && connection) {
			const vaultProgram = getDriftVaultProgram(
				connection,
				createPlaceholderIWallet()
			);
			const vaultClient = new VaultClient({
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				driftClient: driftClient as any, // Type assertion needed due to duplicate @drift-labs/sdk instances
				program: vaultProgram,
			});
			setVaultsStore((s) => {
				s.vaultClient = vaultClient;
			});
		}
	}, [driftClient, driftClientIsReady, connection]);
};
